import { useTranslation } from 'react-i18next';
import { SelfDeclarationDto } from 'src/api/v2';
import { formatDateToNOString } from 'src/utils/FormatValue';
import { getSelfDeclarationStatus, isValidDate } from '../../../utils/self-declaration';

export const useSelfDeclarationDisplay = (selfDeclarations: SelfDeclarationDto[] | undefined) => {
  const { t: tCommon } = useTranslation();

  const latestSelfDeclaration = selfDeclarations
    ?.filter((item) => isValidDate(item.deliveredDate))
    .sort((a, b) => new Date(b.deliveredDate).getTime() - new Date(a.deliveredDate).getTime())[0];

  const deliveredDate = latestSelfDeclaration?.deliveredDate;

  const status = getSelfDeclarationStatus(
    deliveredDate,
    Boolean(latestSelfDeclaration?.selfDeclarationDelivered),
  );

  const { statusText, statusColor } = (() => {
    switch (status) {
      case 'expired':
        return { statusText: tCommon('selfDeclarationExpired'), statusColor: 'danger' as const };
      case 'expiresSoon':
        return { statusText: tCommon('expiresSoon'), statusColor: 'warning' as const };
      case 'delivered':
        return { statusText: tCommon('delivered'), statusColor: 'success' as const };
      case 'missing':
        return { statusText: tCommon('missing'), statusColor: 'neutral' as const };
    }
  })();

  const validToDate = deliveredDate
    ? (() => {
        const d = new Date(deliveredDate);
        d.setFullYear(d.getFullYear() + 2);
        return d;
      })()
    : undefined;

  const validToText = validToDate
    ? formatDateToNOString(validToDate, false, '{date}.{month}.{year}', true)
    : tCommon('notSet');

  return { latestSelfDeclaration, statusText, statusColor, validToDate, validToText };
};
